// extracted by mini-css-extract-plugin
export var container = "index-module--container--+1Q+G";
export var description = "index-module--description--apzlI";
export var tagContainer = "index-module--tagContainer--C09Qi";